export class NotContainsUppercaseError extends Error {
  constructor () {
    super('O campo deve ter ao menos uma letra maiúscula')
    this.name = 'NotContainsUppercaseError'
  }
}
